var React = require('react');

function ArrowDownBig (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8,16H8a1,1,0,0,1-.38-.08,1,1,0,0,1-.33-.21l-7-7A1,1,0,1,1,1.71,7.29L7,12.59V1A1,1,0,0,1,9,1V12.59l5.29-5.3a1,1,0,1,1,1.42,1.42l-7,7a1,1,0,0,1-.33.21A1,1,0,0,1,8,16Z"}));
}

ArrowDownBig.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ArrowDownBig;

ArrowDownBig.default = ArrowDownBig;
